/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PostCategoryLanguagesResponse } from '../../models/post-category-languages-response';

export interface GetEditorialPostCategoriesLanguages$Params {
}

export function getEditorialPostCategoriesLanguages(http: HttpClient, rootUrl: string, params?: GetEditorialPostCategoriesLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PostCategoryLanguagesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEditorialPostCategoriesLanguages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PostCategoryLanguagesResponse>>;
    })
  );
}

getEditorialPostCategoriesLanguages.PATH = '/api/editorial/post-categories-languages';
